<template>
  <modal 
    name="client-template-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'650px'"
    @before-open="beforeOpen">
    
    <div class="modal-header">
      <div class="modal-title">
        {{ title }}
      </div>

      <a href="#"
        @click.prevent="$modal.hide('asset-template-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body" v-if="template != null">
      <InputText 
        label="Template name" 
        propertyKey="name"
        objectType="template"
        :value="template.name"
        :updateValue="updateValue" />

      <div v-if="nameError !== null" class="text-red-600 mt-1 text-sm">{{ nameError }}</div>

      <div class="label-line text-sm">
        Please select from existing asset, liability and document templates you wish to add to this client template
      </div>

      <div class="label-line label-standard">
        Asset template
      </div>

      <div class="flex items-center form-line">
        <select class="select-standard h-10" v-model="template.data.assetTemplateId">
          <option :value="null">Please select an asset template</option>
          <template v-for="(at, index) in templates">
            <template v-if="at.type == 'asset'">
              <option :value="at.id">{{ at.name }}</option>
            </template>
          </template>
        </select>
      </div>

      <div class="label-line label-standard">
        Liability template
      </div>

      <div class="flex items-center form-line">
        <select class="select-standard h-10" v-model="template.data.liabilityTemplateId">
          <option :value="null">Please select a liability template</option>
          <template v-for="(at, index) in templates">
            <template v-if="at.type == 'liability'">
              <option :value="at.id">{{ at.name }}</option>
            </template>
          </template>
        </select>
      </div>

      <div class="label-line label-standard">
        Document template
      </div>

      <div class="flex items-center form-line">
        <select class="select-standard h-10" v-model="template.data.documentTemplateId">
          <option :value="null">Please select a document template</option>
          <template v-for="(at, index) in templates">
            <template v-if="at.type == 'document'">
              <option :value="at.id">{{ at.name }}</option>
            </template>
          </template>
        </select>
      </div>
    </div>

    <div class="modal-footer">
      <SubmitButton2 label="Save" :onClick="submit" :loading="loading" />
    </div>
  </modal>
</template>

<script>
  import InputRadio     from '@/shared/components/form/InputRadio'
  import InputText      from '@/shared/components/form/InputText'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import { EventBus }   from '@/shared/event-bus'
  import MultipleType   from './MultipleType'

  export default {

    props : {
      templates : {
        type    : Array,
        required: false
      }
    },

    components : {
      InputRadio,
      InputText,
      SubmitButton2,
      MultipleType
    },

    data() {
      return {
        title    : null,
        loading  : false,
        nameError: null,
        template : null,
      }
    },

    methods : {
      beforeOpen(event) {
        if(event.params.template != null) {
          this.title    = "Edit client template"
          this.template = event.params.template
        }

        else {
          this.title    = "Create a client template"
          this.template = {
            type: 'client',
            name: null,
            data: {
              assetTemplateId    : null,
              liabilityTemplateId: null,
              documentTemplateId : null
            }
          }
        }
      },

      updateValue(params) {
        this.template[params.key] = params.value
      },
      
      submit() {
        let valid      = true
        this.nameError = null
        
        if(this.template.name == null || this.template.name.length == 0) {
          this.nameError = "Please provide a valid name for this template"
          valid = false
        }

        if(valid) {
          this.loading = true
          this.apiPost({
            template : this.template
          }, 'template/save', () => {
            this.loading = false
            this.$modal.hide('client-template-modal')
            EventBus.$emit('get-templates')
            EventBus.$emit('notification-event', {
              'type'   : 'success',
              'message': "Template saved successfully"
            })
          })
        }
      },
    }
  }
</script>